export default __webpack_public_path__ + "static/terms-twitter-9c71bdf27aa059c86e76d1cdec0e0bb3.svg";